export default __webpack_public_path__ + "static/media/d317f5a70266591c.12ee9e138ec36460ec718d40e149f1d5.svg";